import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { IconProps } from "./types";

export function ArrowRightIcon({ size, ...props }: IconProps) {
    return (
        <ArrowBackRoundedIcon fontSize={size} style={{ transform: "rotate(180deg)" }} {...props} />
    );
}
